import type { CaseFormData } from '../types/caseForm';

// The form minus its File objects (which don't serialise), for change detection and drafts.
export const serializeForm = (fd: CaseFormData): string => JSON.stringify({ ...fd, files: undefined });

export interface AutosaveState {
  status: 'idle' | 'saving' | 'saved' | 'error';
  savedAt: number | null;
  // Where the draft lives, for the indicator's wording.
  where: 'server' | 'browser';
  onRetry?: () => void;
}
